import React from "react";
import {
  VictoryChart,
  VictoryScatter,
  VictoryLine,
  VictoryTheme,
  VictoryAxis,
  VictoryPortal,
  VictoryLabel,
} from "victory";

interface PlotPoint {
  n: number;
  x: number;
  y: number;
}

interface SquarePlotProps {
  squarrayLength: number;
  plotData: PlotPoint[];
  origin: number;
  linear: number | boolean;
  index: number;
  padding?: number;
}

const SquarePlot: React.FC<SquarePlotProps> = ({
  squarrayLength,
  plotData,
  origin,
  linear,
  index,
  padding = 0,
}) => {
  const maxima = squarrayLength / 2 - 1;
  const bounds = maxima + 2;
  const pointSize = 3;

  const ScatterPlotEventHandlers =
    plotData.length > 501
      ? {}
      : {
          target: "data" as const,
          eventHandlers: {
            onMouseOver: () => {
              return [
                {
                  target: "data" as const,
                  mutation: () => {
                    return { style: { fill: "black" } };
                  },
                },
                {
                  target: "labels" as const,
                  mutation: (props: any) => {
                    return {
                      text: `n: ${props.datum.n},\n x: ${props.datum.x},\n y: ${props.datum.y}`,
                    };
                  },
                },
              ];
            },
            onMouseOut: () => {
              return [
                {
                  target: "data" as const,
                  mutation: () => null,
                },
                {
                  target: "labels" as const,
                  mutation: () => null,
                },
              ];
            },
          },
        };

  return (
    <VictoryChart
      padding={{ top: padding / 2, bottom: padding / 2, left: padding, right: padding }}
      theme={VictoryTheme.material}
      domain={{ x: [-bounds, bounds], y: [-bounds, bounds] }}
    >
      <VictoryAxis
        gridComponent={<></>}
        tickFormat={(t) => (Math.abs(bounds) > 1e6 ? t.toExponential() : t)}
      />
      <VictoryAxis
        dependentAxis
        gridComponent={<></>}
        tickFormat={(t) => (Math.abs(bounds) > 1e6 ? t.toExponential() : t)}
      />
      {Number(linear) - 1 ? (
        <VictoryLine
          style={{
            data: { stroke: "#c43a31" },
            parent: { border: "5px solid #ccc" },
          }}
          sortKey="n"
          data={plotData}
          labels={() => null}
        />
      ) : (
        <VictoryScatter
          style={{
            data: { fill: "#c43a31" },
            labels: { fontSize: 10, fill: "black" },
          }}
          size={pointSize}
          data={plotData}
          labels={() => null}
          labelComponent={
            <VictoryPortal>
              <VictoryLabel />
            </VictoryPortal>
          }
          events={[ScatterPlotEventHandlers as any]}
        />
      )}
    </VictoryChart>
  );
};

export default SquarePlot;


